import { Status } from '../enums/status';

export interface IBidderDomainTag {
	tag: string;
	counter: number;
}

export interface IBidderDomainCounter {
	campaign_id: number;
	counter: number;
	status?: Status;
}

export interface IConflictData {
	campaign_id: number;
	campaign_name: string;
	shared_values: string[] | string;
	conflict_type: string;
	domains_counter: number;
}

export interface ICampaignConflictData {
	campaign_id: number;
	conflict_data: IConflictData[];
	MetaData: {
		campaign_id: number;
	};
}

// Interfaces for getCampaignDomainStatus
export interface ICampaignDomainStateRequest {
	id: number;
	domains: string[];
}

export interface ICampaignDomainStateCacheRequest {
	campaign_id: number;
	domains: string[];
}

export interface ICampaignDomainState {
	action?: string;
	domain: string;
	status: string;
	paused: boolean;
	cache_data?: string;
}

export interface IDomainError {
	domain: string;
	error: string;
}

export interface ICampaignDomainStateResponse {
	campaign_id: number;
	domains: ICampaignDomainState[];
	domain_errors?: IDomainError[];
	MetaData: {
		id: number;
		domains: string[];
	};
}

export interface ICampaignDomainTagCounters {
	campaign_id: number;
	status: Status;
	white_list: IBidderDomainTag[];
	black_list: IBidderDomainTag[];
	last_updated: string;
}

export type IBidderDomainTableModel = ICampaignDomainTagCounters & {
	paused_in_cache?: number;
	domains_in_trash?: number;
	black_list_filter?: string[];
	white_list_filter?: string[];
};

export class CampaignDomainTagCounters {
	campaign_id: number;
	status: Status;
	white_list: IBidderDomainTag[];
	black_list: IBidderDomainTag[];
	last_updated: string;

	constructor(data: ICampaignDomainTagCounters) {
		this.campaign_id = data.campaign_id;
		this.status = data.status;
		this.white_list = data.white_list;
		this.black_list = data.black_list;
		this.last_updated = data.last_updated;
	}
}

export class BidderDomainCounter {
	campaign_id: number;
	counter: number;
	status?: Status;

	constructor(data: IBidderDomainCounter) {
		this.campaign_id = data.campaign_id;
		this.counter = data.counter;
		this.status = data.status;
	}
}

export class BidderDomainTableModel {
	campaign_id: number;
	status: Status;
	white_list: IBidderDomainTag[];
	black_list: IBidderDomainTag[];
	last_updated: string;
	paused_in_cache?: number;
	domains_in_trash?: number;
	black_list_filter?: string[];
	white_list_filter?: string[];

	constructor(data: IBidderDomainTableModel) {
		this.campaign_id = data.campaign_id;
		this.status = data.status;
		this.white_list = data.white_list;
		this.black_list = data.black_list;
		this.last_updated = data.last_updated;
		this.paused_in_cache = data.paused_in_cache;
		this.domains_in_trash = data.domains_in_trash;
		this.black_list_filter = data.black_list_filter;
		this.white_list_filter = data.white_list_filter;
	}
}

export class CampaignDomainStatus {
	domain: string;
	status: string;
	paused: boolean;
	cache_data?: string;

	constructor(data: ICampaignDomainState) {
		this.domain = data.domain;
		this.status = data.status;
		this.paused = data.paused;
		this.cache_data = data.cache_data;
	}
}

export class CampaignDomainStatusResponse {
	campaign_id: number;
	domains: CampaignDomainStatus[];
	domain_errors?: IDomainError[];
	MetaData: {
		id: number;
		domains: string[];
	};

	constructor(data: ICampaignDomainStateResponse) {
		this.campaign_id = data.campaign_id;
		this.domains = data.domains.map(domain => new CampaignDomainStatus(domain));
		this.domain_errors = data.domain_errors;
		this.MetaData = data.MetaData;
	}
}
